import SelectAsyncField from "components/fields/SelectAsyncField";
import { FieldErrors, FieldValues } from "react-hook-form";

interface ICellDropdown<T> {
  id: string;
  label: string;
  placeholder: string;
  value: T;
  errors: FieldErrors<FieldValues>;
  requiredMessage?: string;
  onInputChange: (value: T) => void;
  loadOptions: (
    search: string,
    loadedOptions: any,
    { page }: any
  ) => Promise<{
    options: any[];
    hasMore: boolean;
    additional: {
      page: number;
    };
  }>;
}

const CellDropdown = <T,>(props: ICellDropdown<T>) => {
  const {
    onInputChange,
    loadOptions,
    value,
    errors,
    id,
    label,
    placeholder,
    requiredMessage,
  } = props;

  return (
    <SelectAsyncField
      loadOptions={loadOptions}
      onInputChange={onInputChange}
      value={value}
      id={id}
      label={label}
      placeholder={placeholder}
      extra="mb-3 flex-1 w-full"
      errors={errors}
      rules={requiredMessage ? { required: requiredMessage } : {}}
    />
  );
};

export default CellDropdown;
